import { useState } from 'react';
import './NewApplication.css';
import NewPatentApplicationForm from '../NewPatentApplicationForm/NewPatentApplicationForm';
import NewTrademarkApplicationForm from '../NewTrademarkApplicationForm/NewTrademarkApplicationForm';
import { findClientByNumber } from '../../utilities/api/clients';



export default function NewApplication({user, updatePatentApplications, updateTrademarkApplications, toggleNotifications}) {
    const [applicationType, setApplicationType] = useState('')

    const checkForClient = async (clientNumber) => {
        try {
            const client = await findClientByNumber(clientNumber)
            if (client) {
                return client
            } else {
                return null
            }
        } catch (err) {
            console.log(err)
        }
    }

    function handleApplicationTypeChange(evt) {
        setApplicationType(evt.target.value);
    }

  return (
    <div className='NewApplication modal fade' id={`newApplicationModal`}  data-bs-keyboard="true">
        <div className="modal-dialog">
            <div className="modal-content formContainer">
                <div className='header'>
                    <div className='left'>
                        <div className='first'>
                            <svg width="25" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                                <rect x="1.47275" y="17.1" width="16.2" height="6.48374" rx="3.24187" transform="rotate(-90 1.47275 17.1)" stroke="currentColor" strokeWidth="1.2"/>
                                <rect x="8.57383" y="17.1" width="16.2" height="6.48374" rx="3.24187" transform="rotate(-90 8.57383 17.1)" stroke="currentColor" strokeWidth="1.2"/>
                            </svg>
                        </div>
                        <div className='second'>
                            <div className='sec1'>
                                Add Application 
                            </div>
                        </div>
                    </div>
                    <div className='right'>
                        <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                            <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className='mainContainer'>
                    <div className='selectApplicationType'>
                        <div className='formGroupLabel'>
                            <label htmlFor='patentOrTrademarkApplicationType'>Select Application Type:</label>
                        </div>
                        <div className='formGroupInput w-100'>
                            <select id='patentOrTrademarkApplicationType' className='form-select' value={applicationType} onChange={handleApplicationTypeChange}>
                                <option value='' disabled>---Select Application Type---</option>
                                <option value='patentApplication'>Patent Application</option>
                                <option value='trademarkApplication'>Trademark Application</option>
                            </select>
                        </div>
                    </div>
                    { applicationType === '' &&
                    <div className='selectApplicationType'>
                        <strong className='errorText'>Select an application type to get started.</strong>
                    </div>
                    }
                    { applicationType === 'patentApplication' &&
                    <NewPatentApplicationForm user={user} checkForClient={checkForClient} toggleNotifications={toggleNotifications} updatePatentApplications={updatePatentApplications} />
                    }
                    { applicationType === 'trademarkApplication' &&
                    <NewTrademarkApplicationForm user={user} checkForClient={checkForClient} toggleNotifications={toggleNotifications} updateTrademarkApplications={updateTrademarkApplications} />
                    }
                </div>
            </div>
        </div>
    </div>
  )
}
